function decodeHTMLEntities(rawStr) {
  return rawStr.replace(/&#(\d+);/g, ((match, dec) => `${String.fromCharCode(dec)}`));
}

export function MatchHighlight({ text, tokens } = {}) {
  if (!text || !Array.isArray(tokens)) { return text; }
  
  // eslint-ignore no-useless-escape
  const invalid = /[*°"§%()\[\]{}=\\?´`'#<>|,;.:+_-]+/g;

  const regex = new RegExp(`(${tokens.filter(t => !!t).join('|').replace(invalid, "")})`, "gmi");
  const parts = text.split(regex);

  return (
    <span>
      {parts.map((part, index) =>
        (regex.test(part)
          ? <b key={`match-${index}`}>{decodeHTMLEntities(part)}</b>
          : decodeHTMLEntities(part)
        )
      )}
    </span>
  );
}
